<template>
    <div class="row" v-if="widgetReady">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="widget widget-content flex-container box-mid-margin">
                <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                    <img :src="profileImage" alt="" class="img-responsive img-polaroid center-block">
                </div>
                <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <h4>{{ vm.name }}, {{ vm.designation }}</h4>
                            <p>
                                <button class="btn btn-link btn-xs" style="padding: 0;" @click.prevent="showBio">
                                    About {{ vm.name }}
                                </button>
                            </p>

                            <template v-if="hasAddressSetUp">
                                <dl>
                                    <dt>Address</dt>
                                    <dd v-if="vm.clinicName">{{ vm.clinicName }}</dd>
                                    <dd>{{ vm.address.address1 }}<span v-if="vm.address.address2">, {{ vm.address.address2 }}</span></dd>
                                    <dd>{{ vm.address.city }}, {{ vm.address.stateName }} {{ vm.address.zipCode }}</dd>
                                </dl>
                            </template>

                            <p>Phone: {{ vm.phoneNumber | phoneNumber }}</p>
                            <p v-if="vm.clinicName">
                                <button class="btn btn-link btn-xs" style="padding: 0;" @click="showClinicBio">
                                    About {{ vm.clinicName }}
                                </button>
                            </p>
                        </div>  <!--/close col -->

                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <template v-if="hasAddressSetUp">
                                <div class="text-center">
                                    <a :href="mapUrl"
                                       target="_blank">
                                        <img width="200" height="200" class="physician-map" :src="mapImageUrl">
                                    </a>
                                </div>
                                <div class="text-center">
                                    <a :href="mapUrl" target="_blank">
                                        <small>Click to View</small>
                                    </a>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-center">
                                    <div class="alert alert-warning ">Address has not been set yet.</div>
                                </div>
                            </template>

                        </div>  <!--/close col -->
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <h5 class="text-primary"> Important Information:
                                <br>
                                <small class="text-primary">
                                    *Patient care in this office is a team approach.
                                    Care is provided by either the physician, a physician assistant or nurse practitioner with physician oversight.
                                    Please click the “About us” link to learn more.
                                </small>
                                <br>
                                <small class="text-primary">*Please verify with each practice on services offered.
                                </small>
                            </h5>
                        </div><!--/close col -->
                    </div>  <!--/close row -->
                </div>
            </div>
        </div>
        <ac-modal :title="'About '+vm.name" ref="physicianInfoModal" :size-class="'modal-md'">
            <physician-info :provider-entity-id="providerEntityId">

            </physician-info>
        </ac-modal>
        <ac-modal :title="'About '+vm.clinicName" ref="clinicBioModal" :size-class="'modal-md'">
            <div class="row">
                <div class="col-md-12">
                    <p v-html="clinicBio"></p>
                </div>
            </div>
        </ac-modal>
    </div>
</template>

<script>
    import {common} from "../../../global/common.js";
    import PhysicianInfo from "./PhysicianInfo.vue";
    import AcModal from "../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "PhysicianProfile",
        components: {AcModal, PhysicianInfo},
        props: {providerEntityId: {type: [Number], required: true}},
        data() {
            return {
                vm: {},
                widgetReady: false,
                clinicBio: '',
                staticMapUrl: "https://maps.googleapis.com/maps/api/staticmap"
            };

        },
        async mounted() {
            let data = await $.ajax({type: "Get", url: `Shared/getProviderDetails/${this.providerEntityId}`});
            this.mapData('vm', data);
            this.widgetReady = true;
        },
        computed: {
            hasAddressSetUp() {
                return this.widgetReady && this.hasValue(this.vm.address) && this.hasValue(this.vm.address.addressId);
            },
            profileImage() {
                if (this.widgetReady) {
                    return common.generateImageLink(this.vm.profilePictureId, common.IMAGE_SIZE.MEDIUM.id);
                }
                return "";
            },
            mapUrl() {
                return this.widgetReady && this.hasAddressSetUp ?
                    `http://maps.google.com/?q=${this.vm.address.latitude},${this.vm.address.longitude}`
                    : '';
            },
            mapImageUrl() {
                if (!this.widgetReady || !this.hasAddressSetUp) {
                    return "";
                }
                let address = this.vm.address;
                let mapImagePath = common.appendUrlParameter(this.staticMapUrl, 'zoom', 12);
                mapImagePath = common.appendUrlParameter(mapImagePath, 'size', '200x200');
                mapImagePath = common.appendUrlParameter(mapImagePath, 'maptype', 'roadmap');
                mapImagePath = common.appendUrlParameter(mapImagePath, 'markers', 'color:red|' + address.latitude + ',' + address.longitude);
                mapImagePath = common.appendUrlParameter(mapImagePath, 'key', 'AIzaSyBULgN2oWltDQFqUfdnoAFSg76UcLTbvvM');//Key is now required
                return mapImagePath;
            },
        },
        methods: {
            showBio() {
                this.$refs.physicianInfoModal.open();
            },
            async showClinicBio() {
                if (!this.clinicBio) {
                    let parentInfo = await api.get("Shared", this.providerEntityId, "GetProviderParent");
                    this.clinicBio = parentInfo.about;
                }
                this.$refs.clinicBioModal.open();
            }
        }
    }
</script>

<style scoped>

</style>